import { useQuery } from '@tanstack/react-query';
import { StripeService } from '@/services/stripe.service';

interface UsePaymentMethodsParams {
  memberId: string;
  locationId: string;
  enabled?: boolean;
}

export const usePaymentMethods = ({
  memberId,
  locationId,
  enabled = true,
}: UsePaymentMethodsParams) => {
  return useQuery({
    queryKey: ['paymentMethods', memberId, locationId],
    queryFn: () => StripeService.getPaymentMethods(memberId, locationId),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
